(function () {
	const injectCardDisplayStyles = () => {
		if (document.getElementById("nbd-card-display-style")) return;
		const style = document.createElement("style");
		style.id = "nbd-card-display-style";
		style.textContent = `
			.mobile-facets,
			.facets__wrapper.active {
				z-index: 2001 !important;
			}
			.products-grid__overlay.active {
				z-index: 2000 !important;
			}
			.mobile-facets__close,
			.facets__close {
				z-index: 2002 !important;
			}
			body.overflow-hidden .shopify-section-header {
				visibility: hidden !important;
				pointer-events: none !important;
			}
			@media screen and (max-width: 749px) {
				body.overflow-hidden-mobile .shopify-section-header {
					visibility: hidden !important;
					pointer-events: none !important;
				}
				body.overflow-hidden-mobile .mobile-facets,
				body.overflow-hidden-mobile .mobile-facets__inner {
					background-color: rgb(var(--color-background)) !important;
				}
			}
		`;
		document.head.appendChild(style);
	};

	const tidyCardTitles = () => {
		injectCardDisplayStyles();
		document.querySelectorAll(".product-card").forEach((card) => {
			const title = card.querySelector(".card__title");
			const link = title?.querySelector("a");
			if (!title || !link) return;
			link.classList.add("card__title-link");
		});
	};

	const initSlider = () => {
		const slider = document.querySelector(".swiper-container");
		if (!slider || slider.classList.contains("slider_started") || typeof Swiper === "undefined") return;
		slider.classList.add("slider_started");
		new Swiper(".swiper-container", {
			slidesPerView: 1,
			speed: 250,
			spaceBetween: 0,
			navigation: {
				nextEl: ".product-button-group .swiper-button-next-1",
				prevEl: ".product-button-group .swiper-button-prev-1",
			},
			pagination: {
				el: " .product-card-pagination",
				clickable: true,
			},
		});
	};

	initSlider();
	tidyCardTitles();
	document.addEventListener("shopify:section:load", function () {
		initSlider();
		tidyCardTitles();
	});
})();
